export const STAGE_LABELS = {
  prospect: 'Prospect',
  account_created: 'Account Created',
  first_order_placed: 'First Order Placed',
  active: 'Active',
  warm_inactive: 'Warm Inactive',
  cold_inactive: 'Cold Inactive',
  lost: 'Lost'
};

export const STAGE_TONES = {
  prospect: 'slate',
  account_created: 'blue',
  first_order_placed: 'teal',
  active: 'green',
  warm_inactive: 'amber',
  cold_inactive: 'orange',
  lost: 'red'
};

export const stageLabel = stage => STAGE_LABELS[stage] || stage || '—';

export const formatCurrency = value => {
  const number = Number(value || 0);
  return number.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
};

export const formatNumber = value => Number(value || 0).toLocaleString('en-US');

// Build a single physical-location line: "123 Main St, Lake Charles, LA 70601".
export const formatAddress = company => {
  if (!company) {
    return '';
  }
  const cityState = [company.city, company.state].filter(Boolean).join(', ');
  const cityStateZip = [cityState, company.zip].filter(Boolean).join(' ').trim();
  return [company.address, cityStateZip].filter(Boolean).join(', ');
};

// Format a US phone number for display; leave non-standard values as-is.
export const formatPhone = value => {
  if (!value) {
    return '';
  }
  const digits = String(value).replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return String(value);
};

export const formatDate = value => {
  if (!value) {
    return '—';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const formatDateTime = value => {
  if (!value) {
    return '—';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
};

export const daysSince = value => {
  if (!value) {
    return null;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return Math.floor((Date.now() - date.getTime()) / (24 * 60 * 60 * 1000));
};
